import { Query } from "./query";

export abstract class SearchQuery {

    public static SEARCH_EVENT: string = "aurelia.persistence.search.event";

}
